// The two forms of the site post here; the API mails the team inbox (nea-server, com.nea.contact).
// The recipient is decided by the server, never by this page.
const CONTACT_ENDPOINT = "/api/public/contact";

// Resolves to "sent", "throttled" (rate limit, retry later) or "fallback": the endpoint is off,
// unreachable or refused the request, so the caller hands the message to the visitor's mail app
// instead of claiming a delivery that did not happen.
export const sendContact = async (payload) => {
  try {
    const response = await fetch(CONTACT_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    if (response.ok) return "sent";
    if (response.status === 429) return "throttled";
    return "fallback";
  } catch (error) {
    return "fallback";
  }
};

// Honeypot field: invisible and unreachable for a human, bots fill it and the API drops the request.
export const honeypotStyle = {
  position: "absolute",
  left: "-9999px",
  width: "1px",
  height: "1px",
  opacity: 0,
};
